import React, { useState } from "react";
import { FaqQuetionComponent } from "./faq-quetion.component";
import { data } from "../../data";

interface IFaqQuestionsComponentProps {}

export const FaqQuestionsComponent: React.FC<IFaqQuestionsComponentProps> = (
    props: IFaqQuestionsComponentProps
) => {
    const { faqs } = data;
    const [activeId, setActiveId] = useState<string>(faqs[0].id);

    return (
        <div
            className="faq-container px-xl-5"
            data-aos="fade-up"
            data-aos-delay="200"
        >
            {faqs.map((faq) => {
                return (
                    <FaqQuetionComponent
                        key={faq.id}
                        question={faq.question}
                        answer={faq.answer}
                        id={faq.id}
                        activeId={activeId}
                        setActiveId={setActiveId}
                    />
                );
            })}
        </div>
    );
};
